'use client'

import {ReactNode, useEffect, useRef, useState} from 'react'
import {usePlayButton} from './play-button-context'
import s from './style.module.scss'
import clsx from 'clsx'
import {usePathname, useRouter, useSearchParams} from 'next/navigation'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {focusGameIframe, unmuteGame} from '@app/components/game-player/game-functions'
import {requestFullScreen} from '../../actions-section/buttons/full-screen/full-screen-provider'

type Props = {
  textComponent: ReactNode
  isMobile: boolean
  gameNameEn: string
  gameCode: string
}

export const playBtnId = 'game-play-btn'

const PlayBtnClient = ({textComponent, isMobile, gameNameEn, gameCode}: Props) => {
  const {showGameScreen} = usePlayButton()
  const pathname = usePathname() || ''
  const searchParams = useSearchParams()
  const btnRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (btnRef.current) {
      btnRef.current.focus()
    }
  }, [])

  let currentUrl = pathname
  if (searchParams?.toString()) {
    currentUrl += `?${searchParams.toString()}`
  }

  const handleClick = () => {
    if (isMobile) {
      requestFullScreen()
    }
    showGameScreen()
    focusGameIframe()
    triggerAnalytics('game-play-button-clicked', {
      'game-name': gameNameEn,
      'game-code': gameCode,
    }).sendAll()
    unmuteGame()
  }

  return (
    <button
      className={clsx(s.play_btn, {
        [s.desktop_play_btn]: !isMobile,
      })}
      onClick={handleClick}
      id={playBtnId}
    >
      {textComponent}
    </button>
  )
}

export default PlayBtnClient
